import axios from "axios";

export const adminGetListIndex = async (query) => {
  const url =
    axios.getUri({ url: "/api/admin/es-index", params: query }) ||
    `/api/admin/es-index`;
  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createIndex = async (data) => {
  const url = `/api/admin/es-index`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const activeIndex = async (data) => {
  const url = `/api/admin/es-index/active`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const deactiveIndex = async (data) => {
  const url = `/api/admin/es-index/deactive`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const deleteIndex = async (indexName) => {
  const url = `/api/admin/es-index/${indexName}`;
  return axios(url, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const uploadIndexDocument = async (formData) => {
  const url = `/api/admin/es-index/upload`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
};
